import axios from 'axios'
import Vue from 'vue'

Vue.prototype.axios = axios

const service = axios.create({
  timeout: 60000
})

service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    if (response.status !== 200) {
      Vue.prototype.$notify({ type: 'danger', message: '数据异常，请联系管理员' })
      return
    }
    return response
  },
  (err) => {
    // Sentry.captureException(err, {
    //   level: 'error'
    // })
    return Promise.reject(err)
  }
)

export default service
